import { QuestionBase } from "./question-base";

export class ImageQuestion extends QuestionBase<string> {
  controlType = "image";

  reset(): void {
    this.imageReqs.inputNode.value = null;
    this.imageReqs.fileTooBig = false;
    this.imageReqs.invalidDimensions = false;
  }
}
